import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const PropertyRecord = Record({
  // Is this type enabled or disabled within the interface?
  enabled: true,
  canDelete: true,
  // the other properties
  id: null,
  key: null,
  label: null,
  format: null,
  allowed: List(),
  multiple: false,
  autoCalculate: false,
  autoCalculateType: null,
  indicateItemCompletion: false
});

const data = {
  collections: {
    allowed: "ListOptionRecord"
  }
};
createFromJS.registerCallback("PropertyRecord", createFromJS.createNestedCallback(PropertyRecord, data));
